import { Center, Flex, Image } from "@chakra-ui/react"

export function Footer() {
  return (
    <>
      <div className="gamfi-footer-section pt-70">
        <div className="footer-area">
          <div className="container">
            <Center alignSelf={"center"} w={"full"} className="footer-logo text-center mb-45">
              <Image src="assets/logo-icon.svg" alt="Footer-logo" boxSize="120px"
                objectFit="cover" />
            </Center>
            <div className="footer-mainmenu text-center mb-20">
              <ul>
                <li>
                  <a target="_blank" href="http://hera.finance/">
                    Website
                  </a>
                </li>
                <li>
                  <a target="_blank" href="http://docs.hera.finance/">
                    Docs
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com/heraaggregator">
                    Twitter
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://t.me/heraaggregator">
                    Telegram
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://github.com/heraaggregator">
                    Github
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://linktr.ee/heraaggregator">
                    Links
                  </a>
                </li>
              </ul>
            </div>
            <div className="copyright-area text-center mb-0">
              <div className="dsc mb-0 gafi">
                Copyright © 2022. All Rights Reserved by{" "}
                <a target="_blank" className="gafi" href="https://hera.finance">
                  Hera Finance
                </a>
              </div>
            </div>
            <div className="copyright-area text-center mb-0">
              <div className="dsc mb-37 gafi">
                <a target="_blank" href="https://staking.hera.finance/disclaimers.pdf">Disclaimers</a>
              </div>
            </div>
            <div className="scrollup text-center">
              <a href="#">
                <i className="icon-arrow_up" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modals-title  mb-0" id="exampleModalLabel">
                Connect Wallet
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="icon-x" />
              </button>
            </div>
            <div className="modal-body">
              <p className="mb-20">Please select a wallet to connect</p>
              <div className="connect-section">
                <ul className="heading-list">
                  <li>
                    <a href="#">
                      <span>
                        <img
                          src="assets/images/icons/meta-mask.png"
                          alt="Meta-mask-Image"
                        />
                      </span>
                      MetaMask
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <img
                          src="assets/images/icons/coinbase.png"
                          alt="Coinbase-Image"
                        />
                      </span>
                      Coinbase
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <img
                          src="assets/images/icons/trust.png"
                          alt="Trust-Image"
                        />
                      </span>
                      Trust Wallet
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <img
                          src="assets/images/icons/wallet.png"
                          alt="Wallet-Image"
                        />
                      </span>
                      WalletConnect
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="claimModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modals-title  mb-0" id="exampleModalLabel">
                Claim Hera Token
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="icon-x" />
              </button>
            </div>
            <div className="modal-body">
              <a className="banner-btn black-shape text-center mb-20" href="#">
                <span className="btn-text">Claim Now</span>
              </a>
              <div className="connect-section">
                <ul className="heading-list">
                  <li>
                    <a href="#">1444.78 HERA </a>
                    <a className="claimActive">Claimed</a>
                    <br />
                    <small>Round: #1 - Date: 30.03.2022</small>
                  </li>
                  <li>
                    <a href="#">772.14 HERA </a>
                    <a className="claimPass">Unclaimed</a>
                    <br />
                    <small>Round: #2 - Date: 30.04.2022</small>
                  </li>
                  <li>
                    <a href="#">772.14 HERA </a>
                    <a className="claimPass">Unclaimed</a>
                    <br />
                    <small>Round: #3 - Date: 30.05.2022</small>
                  </li>
                  <li>
                    <a href="#">772.14 HERA </a>
                    <a className="claimPass">Unclaimed</a>
                    <br />
                    <small>Round: #4 - Date: 30.06.2022</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}